import Toast from 'components/Toast';
import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Pages } from 'utils/pages.utils';

interface NotFoundState {
  notFoundPath?: string;
}

// Redirects one level up. If the parent doesn't exist either, this page renders
// again and keeps going up until it reaches an existing route (at the latest '/').
function NotFoundPage() {
  const { pathname, state } = useLocation();
  const notFoundPath = (state as NotFoundState | null)?.notFoundPath;
  const segments = pathname.split('/').filter(Boolean);
  const parentPath = '/' + segments.slice(0, -1).join('/');

  // Only notify on the first hop, the original path is passed along in the state
  useEffect(() => {
    if (!notFoundPath) {
      Toast.warning({
        title: 'Page not found',
        content: `The page ${pathname} does not exist.`,
        toastId: `not-found-${pathname}`,
      });
    }
  }, [notFoundPath, pathname]);

  return (
    <Navigate
      to={parentPath || Pages.home}
      state={{ notFoundPath: notFoundPath ?? pathname } satisfies NotFoundState}
      replace
    />
  );
}

export default NotFoundPage;
